import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AddItemMutationVariables = Types.Exact<{
  input: Types.AddItemInput;
}>;


export type AddItemMutation = { __typename?: 'Mutation', addItem: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateItemMutationVariables = Types.Exact<{
  input: Types.UpdateItemInput;
}>;


export type UpdateItemMutation = { __typename?: 'Mutation', updateItem: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type InactivateItemMutationVariables = Types.Exact<{
  input: Types.InactivateItemInput;
}>;


export type InactivateItemMutation = { __typename?: 'Mutation', inactivateItem: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateItemMutationVariables = Types.Exact<{
  input: Types.ActivateItemInput;
}>;


export type ActivateItemMutation = { __typename?: 'Mutation', activateItem: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteItemMutationVariables = Types.Exact<{
  input: Types.DeleteItemInput;
}>;


export type DeleteItemMutation = { __typename?: 'Mutation', deleteItem: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null } };

export type MergeItemMutationVariables = Types.Exact<{
  input: Types.MergeItemInput;
}>;


export type MergeItemMutation = { __typename?: 'Mutation', mergeItem: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PatchItemMutationVariables = Types.Exact<{
  input: Types.PatchItemInput;
}>;


export type PatchItemMutation = { __typename?: 'Mutation', patchItem: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveItemSubstitutionMutationVariables = Types.Exact<{
  input: Types.RemoveItemSubstitutionInput;
}>;


export type RemoveItemSubstitutionMutation = { __typename?: 'Mutation', removeItemSubstitution: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveItemMinShipQtyMutationVariables = Types.Exact<{
  input: Types.RemoveItemMinShipQtyInput;
}>;


export type RemoveItemMinShipQtyMutation = { __typename?: 'Mutation', removeItemMinShipQty: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type BatchInactivateItemsMutationVariables = Types.Exact<{
  input: Types.BatchInactivateItemsInput;
}>;


export type BatchInactivateItemsMutation = { __typename?: 'Mutation', batchInactivateItems: { __typename?: 'ItemBulkActionPayload', items?: Array<{ __typename?: 'ItemPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type BatchAssignItemStripeTaxCodeMutationVariables = Types.Exact<{
  input: Types.BatchAssignItemStripeTaxCodeInput;
}>;


export type BatchAssignItemStripeTaxCodeMutation = { __typename?: 'Mutation', batchAssignItemStripeTaxCode: { __typename?: 'ItemBulkActionPayload', items?: Array<{ __typename?: 'ItemPayload', errors?: Array<{ __typename?: 'ValidationError', message: string }> | null }> | null, errors?: Array<{ __typename?: 'ValidationError', message: string }> | null } };

export type BatchActivateItemsMutationVariables = Types.Exact<{
  input: Types.BatchActivateItemsInput;
}>;


export type BatchActivateItemsMutation = { __typename?: 'Mutation', batchActivateItems: { __typename?: 'ItemBulkActionPayload', items?: Array<{ __typename?: 'ItemPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type BatchDeleteItemsMutationVariables = Types.Exact<{
  input: Types.BatchDeleteItemsInput;
}>;


export type BatchDeleteItemsMutation = { __typename?: 'Mutation', batchDeleteItems: { __typename?: 'ItemBulkActionPayload', items?: Array<{ __typename?: 'ItemPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateItemAttributesMutationVariables = Types.Exact<{
  input: Types.UpdateItemAttributesInput;
}>;


export type UpdateItemAttributesMutation = { __typename?: 'Mutation', updateItemAttributes: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetItemShippingUomsMutationVariables = Types.Exact<{
  input: Types.SetItemShippingUomsInput;
}>;


export type SetItemShippingUomsMutation = { __typename?: 'Mutation', setItemShippingUoms: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetItemContainerConfigOverrideMutationVariables = Types.Exact<{
  input: Types.SetItemContainerConfigOverrideInput;
}>;


export type SetItemContainerConfigOverrideMutation = { __typename?: 'Mutation', setItemContainerConfigOverride: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearItemContainerConfigOverrideMutationVariables = Types.Exact<{
  input: Types.ClearItemContainerConfigOverrideInput;
}>;


export type ClearItemContainerConfigOverrideMutation = { __typename?: 'Mutation', clearItemContainerConfigOverride: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetItemNoteMutationVariables = Types.Exact<{
  input: Types.SetItemNoteInput;
}>;


export type SetItemNoteMutation = { __typename?: 'Mutation', setItemNote: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetItemPriceLabelMutationVariables = Types.Exact<{
  input: Types.SetItemPriceLabelInput;
}>;


export type SetItemPriceLabelMutation = { __typename?: 'Mutation', setItemPriceLabel: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetItemCharacteristicsMutationVariables = Types.Exact<{
  input: Types.SetItemCharacteristicsInput;
}>;


export type SetItemCharacteristicsMutation = { __typename?: 'Mutation', setItemCharacteristics: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearItemNoteMutationVariables = Types.Exact<{
  input: Types.ClearItemNoteInput;
}>;


export type ClearItemNoteMutation = { __typename?: 'Mutation', clearItemNote: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AssignItemGlAccountsMutationVariables = Types.Exact<{
  input: Types.AssignItemGlAccountsInput;
}>;


export type AssignItemGlAccountsMutation = { __typename?: 'Mutation', assignItemGlAccounts: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddItemUpgradeMutationVariables = Types.Exact<{
  input: Types.AddItemUpgradeInput;
}>;


export type AddItemUpgradeMutation = { __typename?: 'Mutation', addItemUpgrade: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateItemUpgradeMutationVariables = Types.Exact<{
  input: Types.UpdateItemUpgradeInput;
}>;


export type UpdateItemUpgradeMutation = { __typename?: 'Mutation', updateItemUpgrade: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ToggleItemUpgradeDefaultMutationVariables = Types.Exact<{
  input: Types.ToggleItemUpgradeDefaultInput;
}>;


export type ToggleItemUpgradeDefaultMutation = { __typename?: 'Mutation', toggleItemUpgradeDefault: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeactivateItemUpgradeMutationVariables = Types.Exact<{
  input: Types.DeactivateItemUpgradeInput;
}>;


export type DeactivateItemUpgradeMutation = { __typename?: 'Mutation', deactivateItemUpgrade: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UploadItemImageMutationVariables = Types.Exact<{
  input: Types.UploadItemImageInput;
}>;


export type UploadItemImageMutation = { __typename?: 'Mutation', uploadItemImage: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetItemBatchTrackingMutationVariables = Types.Exact<{
  input: Types.SetItemBatchTrackingInput;
}>;


export type SetItemBatchTrackingMutation = { __typename?: 'Mutation', setItemBatchTracking: { __typename?: 'ItemPayload', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CombineItemsMutationVariables = Types.Exact<{
  input: Types.CombineItemsInput;
}>;


export type CombineItemsMutation = { __typename?: 'Mutation', combineItems: { __typename?: 'CombineItemsPayload', survivorId?: string | null, loserId?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RevertItemCombineMutationVariables = Types.Exact<{
  input: Types.RevertItemCombineInput;
}>;


export type RevertItemCombineMutation = { __typename?: 'Mutation', revertItemCombine: { __typename?: 'RevertItemCombinePayload', survivorId?: string | null, loserId?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const AddItemDocument = new TypedDocumentString(`
    mutation AddItem($input: AddItemInput!) {
  addItem(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const UpdateItemDocument = new TypedDocumentString(`
    mutation UpdateItem($input: UpdateItemInput!) {
  updateItem(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const InactivateItemDocument = new TypedDocumentString(`
    mutation InactivateItem($input: InactivateItemInput!) {
  inactivateItem(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const ActivateItemDocument = new TypedDocumentString(`
    mutation ActivateItem($input: ActivateItemInput!) {
  activateItem(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const DeleteItemDocument = new TypedDocumentString(`
    mutation DeleteItem($input: DeleteItemInput!) {
  deleteItem(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      ...RecordValidationError
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}
fragment RecordValidationError on ValidationError {
  code
  message
  recordId
  recordKind
  inUseBreakdown {
    kind
    count
  }
}`);
export const MergeItemDocument = new TypedDocumentString(`
    mutation MergeItem($input: MergeItemInput!) {
  mergeItem(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const PatchItemDocument = new TypedDocumentString(`
    mutation PatchItem($input: PatchItemInput!) {
  patchItem(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const RemoveItemSubstitutionDocument = new TypedDocumentString(`
    mutation RemoveItemSubstitution($input: RemoveItemSubstitutionInput!) {
  removeItemSubstitution(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const RemoveItemMinShipQtyDocument = new TypedDocumentString(`
    mutation RemoveItemMinShipQty($input: RemoveItemMinShipQtyInput!) {
  removeItemMinShipQty(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const BatchInactivateItemsDocument = new TypedDocumentString(`
    mutation BatchInactivateItems($input: BatchInactivateItemsInput!) {
  batchInactivateItems(input: $input) {
    items {
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
export const BatchAssignItemStripeTaxCodeDocument = new TypedDocumentString(`
    mutation BatchAssignItemStripeTaxCode($input: BatchAssignItemStripeTaxCodeInput!) {
  batchAssignItemStripeTaxCode(input: $input) {
    items {
      errors {
        message
      }
    }
    errors {
      message
    }
  }
}
    `);
export const BatchActivateItemsDocument = new TypedDocumentString(`
    mutation BatchActivateItems($input: BatchActivateItemsInput!) {
  batchActivateItems(input: $input) {
    items {
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
export const BatchDeleteItemsDocument = new TypedDocumentString(`
    mutation BatchDeleteItems($input: BatchDeleteItemsInput!) {
  batchDeleteItems(input: $input) {
    items {
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
export const UpdateItemAttributesDocument = new TypedDocumentString(`
    mutation UpdateItemAttributes($input: UpdateItemAttributesInput!) {
  updateItemAttributes(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const SetItemShippingUomsDocument = new TypedDocumentString(`
    mutation SetItemShippingUoms($input: SetItemShippingUomsInput!) {
  setItemShippingUoms(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const SetItemContainerConfigOverrideDocument = new TypedDocumentString(`
    mutation SetItemContainerConfigOverride($input: SetItemContainerConfigOverrideInput!) {
  setItemContainerConfigOverride(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const ClearItemContainerConfigOverrideDocument = new TypedDocumentString(`
    mutation ClearItemContainerConfigOverride($input: ClearItemContainerConfigOverrideInput!) {
  clearItemContainerConfigOverride(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const SetItemNoteDocument = new TypedDocumentString(`
    mutation SetItemNote($input: SetItemNoteInput!) {
  setItemNote(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const SetItemPriceLabelDocument = new TypedDocumentString(`
    mutation SetItemPriceLabel($input: SetItemPriceLabelInput!) {
  setItemPriceLabel(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const SetItemCharacteristicsDocument = new TypedDocumentString(`
    mutation SetItemCharacteristics($input: SetItemCharacteristicsInput!) {
  setItemCharacteristics(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const ClearItemNoteDocument = new TypedDocumentString(`
    mutation ClearItemNote($input: ClearItemNoteInput!) {
  clearItemNote(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const AssignItemGlAccountsDocument = new TypedDocumentString(`
    mutation AssignItemGlAccounts($input: AssignItemGlAccountsInput!) {
  assignItemGlAccounts(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const AddItemUpgradeDocument = new TypedDocumentString(`
    mutation AddItemUpgrade($input: AddItemUpgradeInput!) {
  addItemUpgrade(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const UpdateItemUpgradeDocument = new TypedDocumentString(`
    mutation UpdateItemUpgrade($input: UpdateItemUpgradeInput!) {
  updateItemUpgrade(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const ToggleItemUpgradeDefaultDocument = new TypedDocumentString(`
    mutation ToggleItemUpgradeDefault($input: ToggleItemUpgradeDefaultInput!) {
  toggleItemUpgradeDefault(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const DeactivateItemUpgradeDocument = new TypedDocumentString(`
    mutation DeactivateItemUpgrade($input: DeactivateItemUpgradeInput!) {
  deactivateItemUpgrade(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const UploadItemImageDocument = new TypedDocumentString(`
    mutation UploadItemImage($input: UploadItemImageInput!) {
  uploadItemImage(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const SetItemBatchTrackingDocument = new TypedDocumentString(`
    mutation SetItemBatchTracking($input: SetItemBatchTrackingInput!) {
  setItemBatchTracking(input: $input) {
    item {
      ...ItemDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}`);
export const CombineItemsDocument = new TypedDocumentString(`
    mutation CombineItems($input: CombineItemsInput!) {
  combineItems(input: $input) {
    survivorId
    loserId
    errors {
      code
      message
    }
  }
}
    `);
export const RevertItemCombineDocument = new TypedDocumentString(`
    mutation RevertItemCombine($input: RevertItemCombineInput!) {
  revertItemCombine(input: $input) {
    survivorId
    loserId
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AddItem: build.mutation<AddItemMutation, AddItemMutationVariables>({
      query: (variables) => ({ document: AddItemDocument, variables })
    }),
    UpdateItem: build.mutation<UpdateItemMutation, UpdateItemMutationVariables>({
      query: (variables) => ({ document: UpdateItemDocument, variables })
    }),
    InactivateItem: build.mutation<InactivateItemMutation, InactivateItemMutationVariables>({
      query: (variables) => ({ document: InactivateItemDocument, variables })
    }),
    ActivateItem: build.mutation<ActivateItemMutation, ActivateItemMutationVariables>({
      query: (variables) => ({ document: ActivateItemDocument, variables })
    }),
    DeleteItem: build.mutation<DeleteItemMutation, DeleteItemMutationVariables>({
      query: (variables) => ({ document: DeleteItemDocument, variables })
    }),
    MergeItem: build.mutation<MergeItemMutation, MergeItemMutationVariables>({
      query: (variables) => ({ document: MergeItemDocument, variables })
    }),
    PatchItem: build.mutation<PatchItemMutation, PatchItemMutationVariables>({
      query: (variables) => ({ document: PatchItemDocument, variables })
    }),
    RemoveItemSubstitution: build.mutation<RemoveItemSubstitutionMutation, RemoveItemSubstitutionMutationVariables>({
      query: (variables) => ({ document: RemoveItemSubstitutionDocument, variables })
    }),
    RemoveItemMinShipQty: build.mutation<RemoveItemMinShipQtyMutation, RemoveItemMinShipQtyMutationVariables>({
      query: (variables) => ({ document: RemoveItemMinShipQtyDocument, variables })
    }),
    BatchInactivateItems: build.mutation<BatchInactivateItemsMutation, BatchInactivateItemsMutationVariables>({
      query: (variables) => ({ document: BatchInactivateItemsDocument, variables })
    }),
    BatchAssignItemStripeTaxCode: build.mutation<BatchAssignItemStripeTaxCodeMutation, BatchAssignItemStripeTaxCodeMutationVariables>({
      query: (variables) => ({ document: BatchAssignItemStripeTaxCodeDocument, variables })
    }),
    BatchActivateItems: build.mutation<BatchActivateItemsMutation, BatchActivateItemsMutationVariables>({
      query: (variables) => ({ document: BatchActivateItemsDocument, variables })
    }),
    BatchDeleteItems: build.mutation<BatchDeleteItemsMutation, BatchDeleteItemsMutationVariables>({
      query: (variables) => ({ document: BatchDeleteItemsDocument, variables })
    }),
    UpdateItemAttributes: build.mutation<UpdateItemAttributesMutation, UpdateItemAttributesMutationVariables>({
      query: (variables) => ({ document: UpdateItemAttributesDocument, variables })
    }),
    SetItemShippingUoms: build.mutation<SetItemShippingUomsMutation, SetItemShippingUomsMutationVariables>({
      query: (variables) => ({ document: SetItemShippingUomsDocument, variables })
    }),
    SetItemContainerConfigOverride: build.mutation<SetItemContainerConfigOverrideMutation, SetItemContainerConfigOverrideMutationVariables>({
      query: (variables) => ({ document: SetItemContainerConfigOverrideDocument, variables })
    }),
    ClearItemContainerConfigOverride: build.mutation<ClearItemContainerConfigOverrideMutation, ClearItemContainerConfigOverrideMutationVariables>({
      query: (variables) => ({ document: ClearItemContainerConfigOverrideDocument, variables })
    }),
    SetItemNote: build.mutation<SetItemNoteMutation, SetItemNoteMutationVariables>({
      query: (variables) => ({ document: SetItemNoteDocument, variables })
    }),
    SetItemPriceLabel: build.mutation<SetItemPriceLabelMutation, SetItemPriceLabelMutationVariables>({
      query: (variables) => ({ document: SetItemPriceLabelDocument, variables })
    }),
    SetItemCharacteristics: build.mutation<SetItemCharacteristicsMutation, SetItemCharacteristicsMutationVariables>({
      query: (variables) => ({ document: SetItemCharacteristicsDocument, variables })
    }),
    ClearItemNote: build.mutation<ClearItemNoteMutation, ClearItemNoteMutationVariables>({
      query: (variables) => ({ document: ClearItemNoteDocument, variables })
    }),
    AssignItemGlAccounts: build.mutation<AssignItemGlAccountsMutation, AssignItemGlAccountsMutationVariables>({
      query: (variables) => ({ document: AssignItemGlAccountsDocument, variables })
    }),
    AddItemUpgrade: build.mutation<AddItemUpgradeMutation, AddItemUpgradeMutationVariables>({
      query: (variables) => ({ document: AddItemUpgradeDocument, variables })
    }),
    UpdateItemUpgrade: build.mutation<UpdateItemUpgradeMutation, UpdateItemUpgradeMutationVariables>({
      query: (variables) => ({ document: UpdateItemUpgradeDocument, variables })
    }),
    ToggleItemUpgradeDefault: build.mutation<ToggleItemUpgradeDefaultMutation, ToggleItemUpgradeDefaultMutationVariables>({
      query: (variables) => ({ document: ToggleItemUpgradeDefaultDocument, variables })
    }),
    DeactivateItemUpgrade: build.mutation<DeactivateItemUpgradeMutation, DeactivateItemUpgradeMutationVariables>({
      query: (variables) => ({ document: DeactivateItemUpgradeDocument, variables })
    }),
    UploadItemImage: build.mutation<UploadItemImageMutation, UploadItemImageMutationVariables>({
      query: (variables) => ({ document: UploadItemImageDocument, variables })
    }),
    SetItemBatchTracking: build.mutation<SetItemBatchTrackingMutation, SetItemBatchTrackingMutationVariables>({
      query: (variables) => ({ document: SetItemBatchTrackingDocument, variables })
    }),
    CombineItems: build.mutation<CombineItemsMutation, CombineItemsMutationVariables>({
      query: (variables) => ({ document: CombineItemsDocument, variables })
    }),
    RevertItemCombine: build.mutation<RevertItemCombineMutation, RevertItemCombineMutationVariables>({
      query: (variables) => ({ document: RevertItemCombineDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAddItemMutation, useUpdateItemMutation, useInactivateItemMutation, useActivateItemMutation, useDeleteItemMutation, useMergeItemMutation, usePatchItemMutation, useRemoveItemSubstitutionMutation, useRemoveItemMinShipQtyMutation, useBatchInactivateItemsMutation, useBatchAssignItemStripeTaxCodeMutation, useBatchActivateItemsMutation, useBatchDeleteItemsMutation, useUpdateItemAttributesMutation, useSetItemShippingUomsMutation, useSetItemContainerConfigOverrideMutation, useClearItemContainerConfigOverrideMutation, useSetItemNoteMutation, useSetItemPriceLabelMutation, useSetItemCharacteristicsMutation, useClearItemNoteMutation, useAssignItemGlAccountsMutation, useAddItemUpgradeMutation, useUpdateItemUpgradeMutation, useToggleItemUpgradeDefaultMutation, useDeactivateItemUpgradeMutation, useUploadItemImageMutation, useSetItemBatchTrackingMutation, useCombineItemsMutation, useRevertItemCombineMutation } = injectedRtkApi;
